import { createFileRoute } from "@tanstack/react-router";

import Conversations from "../pages/Conversations";
import { useAppShell } from "../layouts/AppShellContext";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/")({
  component: ConversationsRoute,
});

function ConversationsRoute() {
  const { selectedChatbotId, isSidebarOpen } = useAppShell();

  return (
    <RequireAuth>
      <Conversations selectedChatbotId={selectedChatbotId} isSidebarOpen={isSidebarOpen} />
    </RequireAuth>
  );
}
